<template>
  <div class="container">
    <b-field>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(1)"
                      native-value="1"
                      type="is-primary"
      >1D</b-radio-button>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(4)"
                      native-value="4"
                      type="is-primary"
      >1W</b-radio-button>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(5)"
                      native-value="5"
                      type="is-primary"
      >1M</b-radio-button>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(11)"
                      native-value="11"
                      type="is-primary"
      >2M</b-radio-button>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(12)"
                      native-value="12"
                      type="is-primary"
      >3M</b-radio-button>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(13)"
                      native-value="13"
                      type="is-primary"
      >6M</b-radio-button>
      <b-radio-button v-model="timeFrameId"
                      v-if="isTimeFrameAvailable(14)"
                      native-value="14"
                      type="is-primary"
      >1Y</b-radio-button>
    </b-field>
  </div>
</template>

<script>
  import {mapGetters, mapMutations} from 'vuex';
  import BRadioButton from "buefy/src/components/radio/RadioButton";
  import BField from "buefy/src/components/field/Field";
  import {inArray} from '../utils/utils';

  export default {
    components: {
      BField,
      BRadioButton
    },
    name: "chart-time-frames",
    props: ['graphTemplateId'],
    data() {
      return {
        timeFrameId: "1"
      };
    },
    watch: {
      timeFrameId(value) {
        this['SET_SELECTED_TIME_FRAME'](value);
      }
    },
    computed: {
      ...mapGetters('events', ['selectedTimeFrame', 'selectedTimeFrameId']),
      ...mapGetters('graphs', ['graphTemplateById']),
      graphTemplate() {
        return this.graphTemplateById(this.graphTemplateId);
      }
    },
    methods: {
      ...mapMutations('events', ['SET_SELECTED_TIME_FRAME']),
      isTimeFrameAvailable(timeFrameId) {
        if (this.graphTemplate && this.graphTemplate.definition && typeof this.graphTemplate.definition.timeFrames !== "undefined") {
          return inArray(parseInt(timeFrameId), this.graphTemplate.definition.timeFrames);
        }

        return true;
      }
    },
    mounted() {
      this.timeFrameId = this.selectedTimeFrameId.toString();
    }
  }
</script>

<style scoped>

</style>